module.exports = __webpack_public_path__ + "fonts/fa-solid-900.5ee32f5c.ttf";